export const DELETE_CLASS_ERROR_STATUSES = {
    CLASS_HAS_STUDENTS: 409,
    ONLY_CLASS: 403,
};

export const NOTIFICATION_CLOSE_DELAY = 3000;
export const PRESELECTED_CLASS_LETTER = 'А';
export const PRESELECTED_COLLEGE_GROUP_LETTER = 'СПО-1';
export const PRESELECTED_CLASS_NUMBER = 2;
